(function ($) {

  let $burger = $('.burger');
  let $mobile_menu = $('.mobile-menu');
  let $burger_icon = $('.header-menu-icon');
  let $close_icon = $('.header-menu-close');
  let $mobile_menu_items = $('.mobile-menu-items');
  let $layout_container = $('.layout-container');

  $burger.click(() => {
    if ($burger.hasClass("show-mobile-menu")) {
      // Used to show mobile menu
      // These divs change style based on (not) having the show-mobile-menu class.
      $burger.removeClass("show-mobile-menu");
      $mobile_menu.removeClass("show-mobile-menu");
      $burger_icon.removeClass("show-mobile-menu");
      $close_icon.removeClass("show-mobile-menu");
      $layout_container.removeClass("show-mobile-menu");
      $mobile_menu_items.removeClass("show-mobile-menu");
    } else {
      // Now start showing mobile menu
      $burger.addClass("show-mobile-menu");
      $mobile_menu.addClass("show-mobile-menu");
      $burger_icon.addClass("show-mobile-menu");
      $close_icon.addClass("show-mobile-menu");
      $layout_container.addClass("show-mobile-menu");
      $mobile_menu_items.addClass("show-mobile-menu");
    }
  });

})(jQuery, Drupal);
